import { isEmpty, isEqual, xorWith } from 'lodash'

const isArrayEqual = (x: any, y: any) => isEmpty(xorWith(x, y, isEqual))
export default isArrayEqual
